import React, { useEffect, useState } from "react";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import Productdetails from "../Productsforsell/Productdetails";
import WorkSamples from "../Productsforsell/WorkSamples";
import PricingTerms from "../Productsforsell/PricingTerms";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { getSkills } from "../../../../redux/categary/action";
import { GetCountry } from "../../../../redux/master/action";
import {
  getSellById,
  deleteSell,
  getMineSaleList,
} from "../../../../redux/sale/action";
import Access from "../../../CustomComponents/Access/Access";
import ImportantNoteOTS from "../../../Common/ImportantNote/ImportantNoteOTS";
import PackagedServiceList from "../ALLOTSProductsLists/PackagedServiceList";
import { useLocation } from "react-router-dom";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import TranslatedText from "../../../Common/TranslatedText";
import CloseConfirmModal from "../../../Common/CloseConfirmModal";
import useConfirmRefresh from "../../../../utils/useConfirmRefresh";
import CommissionNote from "../../../Common/ImportantNote/CommissionNote";
import ConfirmModal from "../../../Common/ConfirmModal";

export default function ProductsforSell({ autoOpen }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState("");
  const [activeTab, setActiveTab] = useState("BXPDetails");
  const [modalOpen, setModalOpen] = useState(false);
  const [updateindex, setUpdateindex] = useState(null);
  const [bxpData, setbxpData] = useState("");
  const [modal, setModal] = useState(false);
  const [changesIsThere, setChangesIsThere] = useState(false);
  const [showDraftModal, setShowDraftModal] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
    setModal(false);
  };

  const modalStyle = {
    right: modalOpen ? "0" : "-100%",
  };

  useEffect(() => {
    scrollToTop();
  }, [activeTab]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const packageId = queryParams.get("productid");

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    dispatch(GetCountry());
  }, []);

  const dispatch = useDispatch();
  const getminesalelist = useSelector(
    ({ sale: { getminesalelist } }) => getminesalelist
  );
  const getsalebyid = useSelector(({ sale: { getsalebyid } }) => getsalebyid);

  useEffect(() => {
    dispatch(getMineSaleList());
  }, []);

  const { setOTSAutoOpen } = useRouteBaseStateContext();

  useEffect(() => {
    if (autoOpen) {
      checkaccessss();
      setOTSAutoOpen(false);
    }
  }, [autoOpen]);

  useEffect(() => {
    const isNotEmpty = getsalebyid && Object.keys(getsalebyid).length > 0;
    if (updateindex !== null) {
      if (isNotEmpty) {
        setbxpData(getsalebyid);
      } else {
        setbxpData("");
      }
    }
  }, [getsalebyid, updateindex]);

  const getBXPDATA = (id) => {
    dispatch(getSellById(id));
  };

  const updateBxp = (index) => {
    setUpdateindex(index);
    getBXPDATA(index);
    setModalOpen(true);
    setActiveTab("BXPDetails");
  };

  const deleteee = (id) => {
    dispatch(deleteSell(id, setLoading));
  };

  useEffect(() => {
    dispatch(getSkills());
  }, [dispatch]);

  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modalOpen]);

  useEffect(() => {
    packageId && updateBxp(packageId);
  }, [packageId]);

  const openmodel = () => {
    const draft = localStorage.getItem("BSM_ADD_DRAFT");
    if (draft) {
      setShowDraftModal(true);
    } else {
      setModalOpen(true);
      setbxpData("");
      setActiveTab("BXPDetails");
      setUpdateindex(null);
    }
  };

  const handleConfirmDraft = () => {
    const draft = localStorage.getItem("BSM_ADD_DRAFT");
    if (draft) {
      setbxpData(JSON.parse(draft));
    }
    setModalOpen(true);
    setActiveTab("BXPDetails");
    setUpdateindex(null);
    setShowDraftModal(false);
  };

  const handleCancelDraft = () => {
    localStorage.removeItem("BSM_ADD_DRAFT");
    setModalOpen(true);
    setbxpData("");
    setActiveTab("BXPDetails");
    setUpdateindex(null);
    setShowDraftModal(false);
  };

  useEffect(() => {
    if (modalOpen && updateindex === null && bxpData && Object.keys(bxpData).length > 0) {
      localStorage.setItem("BSM_ADD_DRAFT", JSON.stringify(bxpData));
    }
  }, [bxpData, updateindex, modalOpen]);

  const checkaccessss = () => {
    setModal(true);
  };
  console.log(getsalebyid, 'getsalebyid');

  useConfirmRefresh(modalOpen ? true : false);

  return (
    <>
      <ConfirmModal
        isOpen={showDraftModal}
        toggle={() => setShowDraftModal(!showDraftModal)}
        title="Continue last edit?"
        message="Would you like to continue last edit?"
        onConfirm={handleConfirmDraft}
        onCancel={handleCancelDraft}
        confirmText="Yes"
        cancelText="No"
      />
      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          state={"state"}
          checkpermission={"publish_sale"}
          hitmethod={openmodel}
          checkrole={false}
        />
      ) : (
        ""
      )}
      <div>
        <div
          isOpen={modalOpen}
          keyboard={false}
          className={
            modalOpen
              ? `add-education-modal add-bxp-modal add-overlay-modal-width active`
              : "add-education-modal add-bxp-modal add-overlay-modal-width"
          }
          style={modalStyle}
        >

          <div className={`modal-overlay-sec   ${modalOpen ? 'active' : ''}`}></div>
          <div className="modal-width">
            <div className="modal-head">
              <h3> {updateindex !== null ? "Edit" : "Add"} <TranslatedText i18nKey="BSM1" /></h3>
              <CloseConfirmModal closeModal={closeModal} type={updateindex != null ? "Edit" : "Add"} changesIsThere={updateindex ? true : activeTab != "BXPDetails" ? true : changesIsThere} />
            </div>
            <CommissionNote type={'purchase_sale'} item={<TranslatedText i18nKey="BSM1" />} />

            <div className="tab-bxp">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={
                      activeTab == "BXPDetails"
                        ? "active"
                        : activeTab == "WorkSamples"
                          ? "active"
                          : activeTab == "PricingTerms"
                            ? "active"
                            : ""
                    }
                  >
                    <span>1</span> Product details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={
                      activeTab == "WorkSamples"
                        ? "active"
                        : activeTab == "PricingTerms"
                          ? "active"
                          : ""
                    }
                  >
                    <span>2</span> Product info
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab == "PricingTerms" ? "active" : ""}
                  >
                    <span>3</span> Review & add
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="BXPDetails">
                  <Productdetails
                    updateindex={updateindex}
                    bxpData={bxpData}
                    setbxpData={setbxpData}
                    setActiveTab={setActiveTab}
                    key={modalOpen ? updateindex ?? "add" : "closed"}
                    setChangesIsThere={setChangesIsThere}
                  />
                </TabPane>
                <TabPane tabId="WorkSamples">
                  <WorkSamples
                    updateindex={updateindex}
                    bxpData={bxpData}
                    setbxpData={setbxpData}
                    setActiveTab={setActiveTab}
                    key={modalOpen ? updateindex ?? "add" : "closed"}
                  />
                </TabPane>
                <TabPane tabId="PricingTerms">
                  <PricingTerms
                    updateindex={updateindex}
                    bxpData={bxpData}
                    setbxpData={setbxpData}
                    setActiveTab={setActiveTab}
                    setFormData={setFormData}
                    setModalOpen={setModalOpen}
                    setModal={setModal}
                    key={modalOpen ? updateindex ?? "add" : "closed"}
                  />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </div>

      <div className="packagedservice">
        <div className="packaged-first">
          <h4>Buy & Sell with Market (BSM)</h4>
          <button
            className="buttons border-button"
            onClick={() => {
              checkaccessss();
            }}
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
              alt=""
            />
            Add
          </button>
        </div>
        {Object.keys(getminesalelist).length > 0 ? <PackagedServiceList
          listing={getminesalelist}
          update={updateBxp}
          deleteee={deleteee}
          checksold="1"
        /> : <PostNotFound title={"No Post Found"} height={200} />}
      </div>
    </>
  );
}
